import { useEffect, useState } from "react";
import Navbar from "../navbar/navbar";
import { formatDate, getBase64ImageFromUrl, getUserReceiptList } from "../../services/receipt.service";
import Datatable from "../../datatable/Datatable";
import Swal from "sweetalert2";
import { FaEye } from "react-icons/fa6";
import headerLogo from "../../assets/images/DailyPoojaReport.png"
import { getGotraMasterList, getNakshatraMasterList, getPoojaMasterList } from "../../services/admin.service";
import KanikaReceiptPrint from "../../print/kanikaReceiptPrint";
import PrathanaReceiptPrint from "../../print/prathanaReceiptPrint";
import ReceiptPrint from "../../print/receiptPrint";
import DatePicker from "react-datepicker";
import "../reports/reportModule.css";
import { ReportListHeading, ReportListLoading } from "../reports/ReportListUi";

const UserReceiptsListComponent = () => {

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const startOfMonth = new Date(currentYear, currentMonth, 1);
    const endOfMonth = new Date(currentYear, currentMonth + 1, 0);
    const [fromDate, setFromDate] = useState(startOfMonth);
    const [toDate, setToDate] = useState(endOfMonth);
    const [receiptList, setReceiptList] = useState([]);
    const [loading, setLoading] = useState(true);

    const sqlformatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const paymentTypes = {
        'CA': 'Cash',
        'CQ': 'Cheque',
        'DC': 'Card',
        'RT': 'RTGS',
        'UP': 'UPI',
        'NB': 'Net Banking',
        'WL': 'Wallet',
                'Online': 'Online',
    }

    const getMinDate = () => {
        const currentDate = new Date();
        const minYear = currentDate.getFullYear() - 20;
        return new Date(minYear, currentDate.getMonth(), currentDate.getDate());
    };
    const getMaxDate = () => {
        const currentDate = new Date();
        const maxYear = currentDate.getFullYear() + 50;
        return new Date(maxYear, currentDate.getMonth(), currentDate.getDate());
    };

    useEffect(() => {
        fetchReceiptList(fromDate, toDate);
    }, [fromDate, toDate]);


    const fetchReceiptList = async (from, to) => {
        setLoading(true);
        try {
            const fromDate = sqlformatDate(from);
            const toDate = sqlformatDate(to);
            const response = await getUserReceiptList(fromDate, toDate);
            if (response) {
                setReceiptList(response);
            } else {
                Swal.fire("Error", "Failed to fetch receipt list", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = async (item) => {
        const base64Logo = await getBase64ImageFromUrl(headerLogo);
        const nakshatraList = await getNakshatraMasterList();
        const gotraList = await getGotraMasterList();
        const poojaMasterList = await getPoojaMasterList();
        if (item.poojaType1 === '99') {
            await KanikaReceiptPrint(item, base64Logo, nakshatraList, gotraList);
        } else if (item.poojaType1 === '98') {
            await PrathanaReceiptPrint(item, base64Logo, nakshatraList, gotraList);
        } else {
            await ReceiptPrint(item, base64Logo, poojaMasterList, nakshatraList, gotraList);
        }
    };

    const columns = [
        { name: "SN", selector: (row) => row.sn, sortable: true, align: 'text-center' },
        { name: "Receipt No", selector: (row) => row.receiptNo, sortable: true, align: 'text-center' },
        { name: "Receipt Date", selector: (row) => row.receiptDate, sortable: true, align: 'text-center' },
        { name: "Seva Name", selector: (row) => row.poojaName, sortable: true, align: 'text-start' },
        { name: "Seva Date", selector: (row) => row.poojaDateTime1, sortable: true, align: 'text-center' },
        { name: "Total Amount", selector: (row) => row.totalAmount, sortable: true, align: 'text-center' },
        { name: "Payment Mode", selector: (row) => row.paymentType, sortable: true, align: 'text-center' },
        { name: "Action", selector: (row) => row.action, sortable: true, align: 'text-center' },
    ];

    const mappedData = () => {
        return receiptList.map((item, index) => ({
            sn: index + 1,
            receiptNo: item.receiptNo || '-',
            receiptDate: formatDate(item.receiptDate) || '-',
            poojaName: item.poojaName || '-',
            poojaDateTime1: formatDate(item.poojaDateTime1) || '-',
            totalAmount: item.totalAmount || '-',
            paymentType: paymentTypes[item.paymentType] || '-',
            action: (
                <>
                    <button className="print" onClick={() => handlePrint(item)}><FaEye /></button>
                </>
            )
        }))
    }

    return (
        <div className="card report-list-page">
            <Navbar />
            <ReportListHeading title="Receipt List" subtitle="Find your receipts by date and review payment details." />

            <div className="report-list-toolbar rowHeadercolor">
                <div className="col-md-2 d-flex align-items-center">
                    <label className="font-label me-2 mb-0">From :</label>
                    <DatePicker
                        selected={fromDate}
                        onChange={(newValue) => {
                            setFromDate(newValue);
                        }}
                        className="form-control"
                        placeholderText="From Date"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        minDate={getMinDate()}
                        maxDate={getMaxDate()}
                        onKeyDown={(event) => event.preventDefault()}
                    />
                </div>

                <div className="col-md-2 d-flex align-items-center">
                    <label className="font-label me-2 mb-0">To :</label>
                    <DatePicker
                        selected={toDate}
                        onChange={(newValue) => {
                            setToDate(newValue);
                        }}
                        className="form-control"
                        placeholderText="To Date"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        minDate={getMinDate()}
                        maxDate={getMaxDate()}
                        onKeyDown={(event) => event.preventDefault()}
                    />
                </div>
            </div>

            <div id="card-body customized-card" className="report-list-table">
                {loading ? <ReportListLoading message="Loading your receipts..." /> : <Datatable columns={columns} data={mappedData()} />}
            </div>
        </div>
    )
}

export default UserReceiptsListComponent;